(() => {
  document.querySelectorAll('[data-fab-protein-finder]').forEach((finder) => {
    const answers = {};
    const form = finder.querySelector('[data-finder-form]');
    const questions = [...finder.querySelectorAll('[data-finder-question]')];
    const results = [...finder.querySelectorAll('[data-finder-result]')];
    const emptyState = finder.querySelector('[data-finder-empty]');
    const progress = finder.querySelector('[data-finder-progress]');
    const progressLabel = finder.querySelector('[data-finder-progress-label]');
    const submit = finder.querySelector('[data-finder-submit]');
    const reset = finder.querySelector('[data-finder-reset]');

    const selectedButtonText = (questionName, selector) => {
      const question = finder.querySelector(`[data-finder-question="${questionName}"]`);
      return question?.querySelector('[data-finder-choice][aria-pressed="true"]')?.querySelector(selector)?.textContent.trim() || '';
    };

    const hideResults = () => {
      results.forEach((result) => {
        result.hidden = true;
        result.classList.remove('is-active');
      });
      if (emptyState) emptyState.hidden = false;
      finder.classList.remove('is-submitted');
    };

    const updateProgress = () => {
      const completed = Object.keys(answers).length;
      const remaining = questions.length - completed;
      const isComplete = remaining === 0;

      if (progress) progress.style.width = `${Math.round((completed / questions.length) * 100)}%`;
      if (progressLabel) {
        progressLabel.textContent = isComplete
          ? 'Ready to get your recommendation'
          : completed
            ? `${remaining} question${remaining === 1 ? '' : 's'} remaining`
            : 'Start here';
      }
      if (submit) submit.disabled = !isComplete;
    };

    const calculateMatch = () => {
      const scores = { fx: 0, px: 0, sx: 0 };
      Object.entries(answers).forEach(([question, choice]) => {
        if (!Object.prototype.hasOwnProperty.call(scores, choice)) return;
        scores[choice] += question === 'priority' ? 3 : question === 'goal' ? 2 : 1;
      });
      return Object.keys(scores).sort((a, b) => scores[b] - scores[a])[0];
    };

    const showRecommendation = () => {
      if (Object.keys(answers).length !== questions.length) return;

      const selected = calculateMatch();
      const result = results.find((item) => item.dataset.finderResult === selected);
      if (!result) return;

      if (emptyState) emptyState.hidden = true;
      results.forEach((item) => {
        const active = item === result;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });

      const reasons = result.querySelector('[data-finder-reasons]');
      if (reasons) {
        const priority = selectedButtonText('priority', 'b');
        const routine = selectedButtonText('routine', 'b');
        const goal = selectedButtonText('goal', 'b');
        reasons.innerHTML = [
          `Matches your workout level: ${priority}`,
          `Aligned with your routine: ${routine}`,
          `Supports your selected goal: ${goal}`
        ].map((reason) => `<li>${reason}</li>`).join('');
      }

      finder.classList.add('is-submitted');
      if (progressLabel) progressLabel.textContent = 'Your recommendation is ready';

      if (window.matchMedia('(max-width: 900px)').matches) {
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    questions.forEach((question) => {
      question.querySelectorAll('[data-finder-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          question.querySelectorAll('[data-finder-choice]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          answers[question.dataset.finderQuestion] = button.dataset.finderChoice;
          hideResults();
          updateProgress();
        });
      });
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      showRecommendation();
    });

    finder.querySelectorAll('[data-finder-edit]').forEach((button) => {
      button.addEventListener('click', () => {
        hideResults();
        form?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    reset?.addEventListener('click', () => {
      Object.keys(answers).forEach((key) => delete answers[key]);
      finder.querySelectorAll('[data-finder-choice]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      hideResults();
      updateProgress();
    });

    hideResults();
    updateProgress();
  });
})();
